import React, { useState } from "react";
import "../Styles/WriteComment.css";
import axios from 'axios';


const baseURL = 'https://ratemymajor.onrender.com';
// const baseURL='http://localhost:5001';


function WriteComment() {
  //setters and getters
  const [name, setName] = useState("");
  const [school, setSchool] = useState("");
  const [major, setMajor] = useState("");
  const [review, setReview] = useState("");
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);

  // this function handleClick will keep the user on the comment page if below functions are not true
  const handleClick = (ev) => {
    ev.preventDefault();
    formValidation();



  }

  //check if the form is has all correct options filled out
  const formValidation = () => {
    if (name === "" || school === "" || major === "" || review === "" || name.length < 1) {
      setErr("Field can not be empty!");
      setSuccess(false);
      return;
    } else {
      addReview();
      clearForm();
      setSuccess(true);
    }
  }

  //this function reset the form and clears the data type in on the browser
  const clearForm = () => {
    if (err.length === 0) {
      setName("");
      setMajor("");
      setSchool("");
      setReview("");
    }

    else {
      return;
    }

  }

  //add a review
  const addReview = () => {
    const URL = `${baseURL}/add/${name}/${school}/${major}/${review}`;
    axios.get(URL)
      .then(response => {
        console.log(response.data);
      })
      .catch(err => {
        console.log(err);
      })
  }

  return (
    <div className="form-container">
      <form method="POST" className="form-section">
        <h1> Write A Comment </h1>
        {err && err}
        {!success ? "" : "review successfully submitted"}
        <div className="form-inputs">

          {/* Name */}
          <div className="field">
            <label className='form-label'>Name</label>
            <input onInput={(e) => setName(e.target.value)} value={name} type="text" className="input-ele" name="name" />
          </div>

          {/* School */}
          <div className="field">
            <label className='form-label'>School</label>
            {/* <input onInput = {(e) => setSchool(e.target.value)} type="text" className="input-ele" name="school" placeholder="school"/> */}
            <select className="school-select" value={school} onChange={(e) => setSchool(e.target.value)}>
              <option>--Select School--</option>
              {/* <!-- CUNY Schools --> */}
              <option value="Hunter College">Hunter College</option>
              <option value="Brooklyn College">Brooklyn College</option>
              <option value="Baruch College">Baruch College</option>
              <option value="City College">City College</option>
              <option value="JohnJay College">John Jay College</option>
              <option value="Lehman College">Lehman College</option>
              <option value="Medgar Evers College">Medgar Evers College</option>

              {/* <!-- SUNY Schools --> */}
              <option value="SUNY Albany">SUNY Albany</option>
              <option value="SUNY Binghamton">SUNY Binghamton</option>
              <option value="SUNY Buffalo">SUNY Buffalo</option>
              <option value="SUNY NewPaltz">SUNY New Paltz</option>
              <option value="SUNY StonyBrook">SUNY Stony Brook</option>

              {/* <!-- Other Schools --> */}
              <option value="Fordham University">Fordham University</option>
              <option value="NYU">New York University (NYU)</option>
              <option value="Columbia University">Columbia University</option>
              <option value="The Juilliard School">The Juilliard School</option>
              <option value="Pratt Institute">Pratt Institute</option>
              <option value="Pace University">Pace University</option>
              <option value="New School">The New School</option>
              <option value="Cornell University">Cornell University</option>
            </select>
          </div>

          {/* Major */}
          <div className="field">
            <label className='form-label'>Major</label>
            <select className="major-select" value={major} onChange={(e) => setMajor(e.target.value)}>
              <option>--Select Major--</option>
              <option value="Nursing">Nursing</option>
              <option value="Education">Education</option>
              <option value="History">History</option>
              <option value="Math">Mathematics</option>
              <option value="Statistics">Statistics</option>
              <option value="Sociology">Sociology</option>
              <option value="Psychology">Psychology</option>
              <option value="Human Services">Human Services</option>
              <option value="Dentistry">Dentistry</option>
              <option value="Aviation">Aviation</option>
              <option value="Business">Business</option>
              <option value="Foreign Languages">Foreign Languages</option>
              <option value="Physical Science">Physical Sciences</option>
              <option value="Engineering">Engineering</option>
              <option value="Architecture">Architecture</option>
              <option value="Environmental Science">Environmental Science</option>
              <option value="Medicine">Medicine</option>
              <option value="Communication">Communication</option>
              <option value="Theater">Theater</option>
              <option value="Music">Music</option>
              <option value="Art">Art</option>
              <option value="Psychiatry">Psychiatry</option>
              <option value="Economics">Economics</option>
              <option value="Political Science">Political Science</option>
              <option value="Philosophy">Philosophy</option>
              <option value="Computer Engineering">Computer Engineering</option>
              <option value="Chemistry">Chemistry</option>
              <option value="Biology">Biology</option>
              <option value="English Literature">English Literature</option>
              <option value="Linguistics">Linguistics</option>
              <option value="Physics">Physics</option>
              <option value="Architecture">Architecture</option>
              <option value="Film Studies">Film Studies</option>
              <option value="Finance">Finance</option>
              <option value="Marketing">Marketing</option>
              <option value="Graphic Design">Graphic Design</option>
              <option value="Sustainable Development">Sustainable Development</option>
              <option value="Law">Law</option>
              <option value="Nutrition">Nutrition</option>
              <option value="Information Technology">Information Technology</option>
              <option value="Public Health">Public Health</option>
              <option value="Social Work">Social Work</option>
              <option value="Urban Planning">Urban Planning</option>
            </select>
            {/* <input onInput = {(e) => setMajor(e.target.value)} type="text" className="input-ele" name="major" placeholder="major"/> */}
          </div>

          {/* Review */}
          <div className="field">
            <textarea onInput={(e) => setReview(e.target.value)} rows="3" cols="5" value={review} className="text-area-review" maxLength="250" placeholder="Write your feedback" />
          </div>


          {/* Submit */}
          <div>
            <button type="submit" onClick={handleClick} className="field-btn" >Submit</button>
          </div>

        </div>
      </form>

    </div>
  );
}

export default WriteComment;